/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useState } from 'react';
import { Modal } from 'antd';
import { useIntl } from 'react-intl';
import { ModalProps } from 'antd/lib/modal';

import { ModalTitle } from '~components/_common/ModalTitle/ModalTitle';
import QuestionsChangeLogList from './QuestionsChangeLogList';
import { DbQuestionChangeLogItem } from '~src/types/db';

export interface QuestionsChangeLogModalProps
  extends Pick<ModalProps, 'visible'> {
  questionId: number;
  isLoading?: boolean;
  questionLogs?: DbQuestionChangeLogItem[];
  onCancel?: () => void;
}

export const QuestionsChangeLogModal: React.FC<QuestionsChangeLogModalProps> = ({
  questionId,
  questionLogs,
  isLoading,
  onCancel,
  ...modalProps
}) => {
  const intl = useIntl();

  return (
    <Modal
      title={
        <ModalTitle
          text={intl.formatMessage({
            id: 'messages-history',
          })}
          icon={['far', 'question-circle']}
        />
      }
      okButtonProps={{ style: { display: 'none' } }}
      cancelButtonProps={{ style: { display: 'none' } }}
      cancelText={intl.formatMessage({ id: 'cancel' })}
      centered
      onCancel={onCancel}
      destroyOnClose
      zIndex={2000}
      width={800}
      bodyStyle={{ maxHeight: '70vh', overflowY: 'auto' }}
      {...modalProps}>
      <QuestionsChangeLogList
        isLoading={!!isLoading}
        questionLogs={questionLogs
          ?.slice()
          .sort(
            (a, b) =>
              new Date(b.created_at).getTime() -
              new Date(a.created_at).getTime()
          )}
      />
    </Modal>
  );
};
